<template>
    <div>
        <div class="row mb-1">
            <div class="col-12">
                <textarea
                        :id="controlId"
                        :name="controlId"
                        class="form-control text-area"
                        type="text"
                        :disabled="!isEnabled"
                        v-model="newValue"
                        cols="5"
                        rows="5"
                >
                </textarea>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    import resourceMixin from '../../../../../Util/Mixins/resources';
    import guidMixin from '../../../../../Util/Mixins/guid';

    export default {
        name: 'info-text-area-input',
        mixins: [resourceMixin, guidMixin],
        created() {
            this.newValue = this.value;
        },
        data() {
            return {
                controlId: this.guid(),
                newValue: ''
            };
        },
        watch: {
            newValue(value) {
                this.$emit('input', value);
            }
        },
        props: {
            value: {
                type: String,
                default: ""
            },
            isEnabled: {
                type: Boolean,
                required: true
            }
        }
    }
</script>

<style scoped src="../../../Style/info-text-area-input.scss" lang="scss">

</style>
